import React, { useEffect, useState } from 'react';
import { Card, Col, ListGroup, Row } from 'react-bootstrap';
import AuthService from '../../../../controllers/AuthService';
import Slider from "react-slick";
import CardYear from '../../../CardYear';

const UserAndActivitySummary = props => {

    const currentTab = props.currentTab ?? null
    const homeroomD1 = props.homeroomD1 ?? null
    const [featureHomeroom, setFeatureHomeroom] = useState(false);
    const userFeature = AuthService.getCurrentUserFeatures();

    useEffect(() => {
        setFeatureHomeroom(userFeature.includes('homeroom'));
    }, [currentTab, homeroomD1])


    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        slidesPerRow: 1,
        centerMode: true,
        arrows: false
    };


    return (
        <>
            <div>
                <Row className="font-sarabun mt-3 mb-3 mt-lg-5 mb-lg-4">
                    <Col xs={12} className="text-center">
                        <h2 className="font-sarabun-bold mb-0 pt-4">
                            จำนวน User และจำนวนกิจกรรม
                        </h2>
                        {/* <button className="btn-showhide border-gray showhide-red d-none d-lg-inline" id="showHideTopStrengthSummary" onClick={() => showHideSection('showHideTopStrengthSummary')}> </button> */}
                    </Col>
                </Row>
                <Slider {...settings} className="d-block d-lg-none">
                    <div style={{ "marginRight": "20px" }}>
                        {(currentTab && homeroomD1) ? <CardYear year="1" grade={currentTab} totalActivity={homeroomD1[0]} homeRoomFeature={featureHomeroom} /> : null}
                    </div>
                    <div>
                        {(currentTab && homeroomD1) ? <CardYear year="2" grade={currentTab} totalActivity={homeroomD1[1]} homeRoomFeature={featureHomeroom} /> : null}
                    </div>
                    <div>
                        {(currentTab && homeroomD1) ? <CardYear year="3" grade={currentTab} totalActivity={homeroomD1[2]} homeRoomFeature={featureHomeroom} /> : null}
                    </div>
                    <div>
                        {(currentTab && homeroomD1) ? <CardYear year="4" grade={currentTab} totalActivity={homeroomD1[3]} homeRoomFeature={featureHomeroom} /> : null}
                    </div>
                    <div>
                        {(currentTab && homeroomD1) ? <CardYear year="5" grade={currentTab} totalActivity={homeroomD1[4]} homeRoomFeature={featureHomeroom} /> : null}
                    </div>
                    <div>
                        {(currentTab && homeroomD1) ? <CardYear year="6" grade={currentTab} totalActivity={homeroomD1[5]} homeRoomFeature={featureHomeroom} /> : null}
                    </div>

                </Slider>
                <Row className="d-none d-lg-flex">
                    <Col xs={12} lg={3} className="pt-4">
                        {(currentTab && homeroomD1) ? <CardYear year="1" grade={currentTab} totalActivity={homeroomD1[0]} homeRoomFeature={featureHomeroom} /> : null}
                    </Col>
                    <Col xs={12} lg={3} className="pt-4">
                        {(currentTab && homeroomD1) ? <CardYear year="2" grade={currentTab} totalActivity={homeroomD1[1]} homeRoomFeature={featureHomeroom} /> : null}
                    </Col>
                    <Col xs={12} lg={3} className="pt-4">
                        {(currentTab && homeroomD1) ? <CardYear year="3" grade={currentTab} totalActivity={homeroomD1[2]} homeRoomFeature={featureHomeroom} /> : null}
                    </Col>
                    <Col xs={12} lg={3} className="pt-4">
                        {(currentTab && homeroomD1) ? <CardYear year="4" grade={currentTab} totalActivity={homeroomD1[3]} homeRoomFeature={featureHomeroom} /> : null}
                    </Col>
                    <Col xs={12} lg={3} className="pt-4">
                        {(currentTab && homeroomD1) ? <CardYear year="5" grade={currentTab} totalActivity={homeroomD1[4]} homeRoomFeature={featureHomeroom} /> : null}
                    </Col>
                    <Col xs={12} lg={3} className="pt-4">
                        {(currentTab && homeroomD1) ? <CardYear year="6" grade={currentTab} totalActivity={homeroomD1[5]} homeRoomFeature={featureHomeroom} /> : null}
                    </Col>
                </Row>
            </div>
        </>
    )

}

export default UserAndActivitySummary